
import Phaser from 'phaser';

export default class OrbitingSprite {
  constructor() {
    this.counter = 0;
    this.step = Math.PI * 2 / 360;
    this.floatingEnabled = true;
    this.rotationScale = 0.02;
  }

  Update() {
    if (this.sprite !== null && this.floatingEnabled) {
      const tStep = Math.sin(this.counter);
      this.sprite.y = tStep * 10 + this.y;
      this.sprite.angle = this.rotationScale * tStep;
      this.counter += this.step;
    }
  }
}


